<div
  [style.--padding-x]="paddingX"
  [style.--rounded]="rounded"
  class="category {{ backgroundClass }}"
>
  <span class="{{ colorClass }} {{ textClass }}">{{ title || 'N/A' }}</span>
</div>
